import { getTrackingCookies } from "./../cookie"

const privacy_names = ["privacy_consent", "privacy_marketing", "privacy_recall"]

export const hubspotEnvID = () => {
  //return isProductionHubspot() ? "9148992" : "9148992"
  return isProductionHubspot() ? "9148992" : "39733156"
}

export const isProductionHubspot = () => {
  const productionHost = [
    "www.fabrick.com",
    "fabrick.com",
    "fabrick-website-pro.fabrick.dev",

    "fabrick-website-uat.fabrick.dev"
  ]

  return typeof window !== 'undefined' ? productionHost.indexOf(window.location.host) !== -1 : true
}

export const hubspotSubmitForm = async (data = {}, formIdProduzione, formIdTest) => {
  let formId = ''
  if (isProductionHubspot()) {
    if (formIdProduzione) {
      formId = formIdProduzione
    } else {
      return false
    }
  } else {
    if (formIdTest) {
      formId = formIdTest
    } else {
      return false
    }
  }

  let fields = { ...data }
  Object.keys(fields).forEach(key => {
    if (privacy_names.includes(key)) {
      delete fields[key]
    }
  })

  const result = await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${hubspotEnvID()}/${formId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      "submittedAt": Date.now(),
      "fields": [{
        "objectTypeId": "0-1",
        "name": "idads",
        "value": fields["email"]
      },
      ...Object.keys(fields).map(key => {
        return typeof fields[key] !== "object" && key !== "recaptcha" ? {
          "objectTypeId": "0-1",
          "name": key,
          "value": fields[key] ? fields[key] : ""
        } : null
      }).filter(value => value !== null)
      ],
      "context": {
        "hutk": getCookie("hubspotutk"),
        "pageName": window.document.title,
        "pageUri": window.location.href
      },
      "legalConsentOptions": {
        "consent": {
          "consentToProcess": true,
          // Boolean; Whether or not the visitor checked the Consent to process checkbox
          "text": "Text that gives consent to process",
          // String; The text displayed to the visitor for the Consent to process checkbox
          "communications": estractCommunicationsValues(data)
        }
      }
    })
  })

  return result.status === 200 || result.status === 201
}

//cerca le privacy dentro i valori del form: se li trova li aggiunge e ritorna
//Perché viene fatto? Ogni form ha privacy diverse, quindi dobbiamo cercarli tutti 
//e prendere solo quelli che servono
const estractCommunicationsValues = (values) => {
  return privacy_names.map(name => {
    if (Object.keys(values).includes(name)) {
      return {
        "value": values[name],
        "subscriptionTypeId": mappingNameToSubscriptionType(name),
        "text": mappingNameToText(name)
      }
    } else {
      return null
    }
  }).filter(value => value !== null)

}

const mappingNameToSubscriptionType = (name) => {
  switch (name) {
    case 'privacy_consent': // sales
      return isProductionHubspot() ? "58884394" : "273898700"
    case 'privacy_marketing':
      return isProductionHubspot() ? "26980259" : "273898590"
    case 'privacy_recall':
      return isProductionHubspot() ? "26980226" : ""
    default:
      return false
  }
}

const mappingNameToText = (name) => {
  switch (name) {
    case 'privacy_consent': // sales
      return "FBK - Consenso al trattamento dei dati personali per recall commerciale B"
    case 'privacy_marketing':
      return "FBK - Consenso al trattamento dei dati personali per ricevere la newsletter"
    case 'privacy_recall':
      return "FBK - Consenso al trattamento dei dati personali e recall richiesta contatto"
    default:
      return false
  }
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

const extractTrackingCodesForCRM = () => {
  const { utm_source, utm_medium, gclid, idads, _gl } = getTrackingCookies()

  if (gclid || idads || _gl) {
    return values("paid", "advertising", "Paid Search")
  }

  if (utm_medium.includes("cpc")) {
    return values("paid", "advertising", "Paid Search")
  }

  if (utm_medium.includes("display")) {
    return values("paid", "advertising", "Display")
  }

  if (utm_medium.includes("youtube")) {
    return values("paid", "social", "Youtube")
  }

  if (utm_source.includes("hs_email") || utm_source.includes("hs_automation")) {
    return values("no_paid", "mail", "Website")
  }

  if (utm_medium.includes("ped") && (utm_source.includes("linkedin") || utm_source.includes("instagram") || utm_source.includes("facebook") || utm_source.includes("tiktok"))) {
    return values("no_paid", "social", utm_source)
  }

  if (utm_medium.includes("paid") && (utm_source.includes("linkedin") || utm_source.includes("instagram") || utm_source.includes("facebook") || utm_source.includes("tiktok"))) {
    return values("paid", "social", utm_source)
  }

  if (utm_medium.includes("dark") && (utm_source.includes("linkedin") || utm_source.includes("instagram") || utm_source.includes("facebook") || utm_source.includes("tiktok"))) {
    return values("paid", "social", utm_source)
  }

  if (utm_source.includes("spotify")) {
    return values("paid", "advertising", "Website")
  }

  if (utm_source.includes("reddit")) {
    return values("paid", "social", "Reddit")
  }

  if (utm_source.includes("linkedinMC")) {
    return values("paid", "social", "Linkedin MC")
  }

  if (utm_source.includes("teadsMC")) {
    return values("paid", "advertising", "Teads MC")
  }

  if (utm_source.includes("evolutionMC")) {
    return values("paid", "advertising", "Evolution MC")
  }

  if (utm_source.includes("impact") || utm_source.includes("affiliation")) {
    return values("paid", "advertising", "Affiliation")
  }

  if ((utm_source && utm_source !== "") || (utm_medium && utm_medium !== "")) {
    return values("unknown", "referral", "Website")
  }


  return values("no_paid", "organic_direct", "Website")

  function values(source, channel, channel_details) {
    return {
      "last_source": source,
      "last_channel": channel,
      "last_channel_detail": channel_details
    }
  }
}

export const extractTrackingForCRM = (firstTouchpoint) => {
  if (window.document) {

    //today midnight
    const today = new Date()
    today.setUTCHours(0, 0, 0, 0)

    //tracking url first visit
    const params = getCookie("f_tracking_params")
    const tracking_url = window.location.host + window.location.pathname + (params && params !== "" ? params : '')


    return {
      ...extractTrackingCodesForCRM(),
      "last_touchpoint": firstTouchpoint,
      "last_url": tracking_url,
      "last_source_date": today.getTime(),
    }
  }

  return {}
}


export function trackError(form, message) {
  if (window) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'errore-form',
      'eventName': 'errore-form',
      'formName': form,
      'formText': message
    })
  }
}

